import type { FlexContainerImageProps } from "./flex-container-image.type";

import ImageWithPreviewModal from "@/modules/image-with-preview-modal";

import FlexContainer from "../flex-container.component";

const FlexContainerImage = ({
  document,
  ...containerProps
}: FlexContainerImageProps) => (
  <FlexContainer
    {...containerProps}
    value={
      <ImageWithPreviewModal
        width="100%"
        src={document.url}
        alt={document.name}
      />
    }
  />
);

export default FlexContainerImage;
